import styled from '@react-pdf/styled-components'

export {styled}


// WEBPACK FOOTER //
// ./src/modules/pdf/pdfDeps.ts